var $45901ec53360e327$exports = {};
let $45901ec53360e327$var$state = $45901ec53360e327$var$initialState();
let $45901ec53360e327$var$highScore = localStorage["high-score"] || 0;
//
// function updateStylesheets() {
//     const element = document.createElement("style");
//     element.id = "color-css";
//
//     document.querySelector('head').append(element);
//     const stylesheet = document.styleSheets[document.styleSheets.length - 1];
//     // hsl
//     let r = [];
//     for (let i = 0; i < 14; ++i) {
//         const n = Math.pow(2, i);
//         //const color = `lch( ${95 - 5 * i}% ${50 + i * 10} ${140 - i * 6} )`;
//          const color = `lch( ${25 + 5 * i}% ${50 + i * 10} ${140 - i * 6} )`;
//
//         const rule = `.value-${n} { background: ${color}; }`;
//         r.push(`  --color-${i}: ${color};`);
//         stylesheet.insertRule(rule);
//     }
//     console.log(r.join('\n'));
// }
//
// updateStylesheets();
document.onkeydown = function(event) {
    if (!$45901ec53360e327$var$state.playing) return;
    switch(event.code){
        case "ArrowLeft":
            $45901ec53360e327$var$moveLeft();
            break;
        case "ArrowUp":
            $45901ec53360e327$var$moveUp();
            break;
        case "ArrowRight":
            $45901ec53360e327$var$moveRight();
            break;
        case "ArrowDown":
            $45901ec53360e327$var$moveDown();
            break;
        default:
    }
};
let $45901ec53360e327$var$touchX = 0;
let $45901ec53360e327$var$touchY = 0;
document.addEventListener("touchstart", (e)=>{
    $45901ec53360e327$var$touchX = e.changedTouches[0].screenX;
    $45901ec53360e327$var$touchY = e.changedTouches[0].screenY;
});
document.addEventListener("touchend", (e)=>{
    const endX = e.changedTouches[0].screenX;
    const endY = e.changedTouches[0].screenY;
    console.log("SWIPE !", $45901ec53360e327$var$touchX, endX, $45901ec53360e327$var$touchY, endY);
    if (Math.abs($45901ec53360e327$var$touchX - endX) > Math.abs($45901ec53360e327$var$touchY - endY)) {
        // x swipe
        if ($45901ec53360e327$var$touchX - endX > 50) $45901ec53360e327$var$moveLeft();
        if (endX - $45901ec53360e327$var$touchX > 50) $45901ec53360e327$var$moveRight();
    } else {
        if ($45901ec53360e327$var$touchY - endY > 50) $45901ec53360e327$var$moveUp();
        else if (endY - $45901ec53360e327$var$touchY > 50) $45901ec53360e327$var$moveDown();
    }
});
document.getElementById("restart").addEventListener("click", function() {
    $45901ec53360e327$var$resetBoard();
});
function $45901ec53360e327$var$orderCells(cells) {
    cells.sort((a, b)=>{
        if (a.left === b.left) return a.top - b.top;
        else return a.left - b.left;
    });
}
function $45901ec53360e327$var$makeCell(left, top, value) {
    const element = document.createElement("div");
    element.innerText = value + "";
    element.className = `cell top-${top} left-${left} value-${value} `;
    return element;
}
function $45901ec53360e327$var$addRandomCell(state) {
    const free = [];
    for(let i = 0; i < 4; ++i)for(let j = 0; j < 4; ++j){
        const present = state.cells.filter((c)=>c.top === j && c.left === i).length > 0;
        if (!present) free.push([
            i,
            j
        ]);
    }
    const chosen = Math.floor(Math.random() * free.length);
    const [left, top] = free[chosen];
    const r = Math.random();
    let value = 1;
    if (r < 0.1) value = 4;
    else if (r < 0.4) value = 2;
    // console.log("Adding random element at",left, top,"with value",value);
    // console.log("Existing values are", state.cells);
    const element = $45901ec53360e327$var$makeCell(left, top, value);
    const cell = {
        element: element,
        left: left,
        top: top,
        value: value
    };
    const newState = {
        ...state,
        cells: [
            ...state.cells,
            cell
        ]
    };
    $45901ec53360e327$var$orderCells(newState.cells);
    return newState;
}
function $45901ec53360e327$var$initialState() {
    let state = {
        cells: [],
        removed: [],
        playing: true,
        score: 0
    };
    for(let i = 0; i < 4; ++i)state = $45901ec53360e327$var$addRandomCell(state);
    console.log("Initial state", state);
    return state;
}
function $45901ec53360e327$var$resetBoard() {
    $45901ec53360e327$var$state = $45901ec53360e327$var$initialState();
    document.getElementById("game").replaceChildren();
    $45901ec53360e327$var$refreshBoard($45901ec53360e327$var$state);
}
function $45901ec53360e327$var$getRow(state, row, reverse) {
    const result = [];
    for (const cell of state.cells)if (cell.top === row) result.push(cell);
    if (reverse) result.reverse();
    return result;
}
function $45901ec53360e327$var$getColumn(state, column, reverse) {
    const result = [];
    for (const cell of state.cells)if (cell.left === column) result.push(cell);
    if (reverse) result.reverse();
    return result;
}
function $45901ec53360e327$var$move(oldState, direction) {
    let extraScore = 0;
    const getter = direction == "up" || direction == "down" ? $45901ec53360e327$var$getColumn : $45901ec53360e327$var$getRow;
    const reverse = direction == "up" || direction == "left" ? false : true;
    const changingField = direction == "up" || direction == "down" ? "top" : "left";
    const newCells = [];
    const deleted = [];
    for(let i = 0; i < 4; ++i){
        // console.log("Processing row/column", i);
        let merged = false;
        const elements = getter(oldState, i, reverse);
        // console.log("Elements of", i, ":", elements);
        const result = [];
        for(let j = 0; j < elements.length; ++j)if (j > 0 && !merged && elements[j].value === elements[j - 1].value) {
            const cur = result.length - 1;
            // console.log("Merging element", j, "into previous because both have value", elements[j].value);
            merged = true;
            // remove the previous
            result[cur][changingField] = reverse ? 3 - cur : cur;
            deleted.push(result[cur]);
            result[cur] = {
                ...elements[j]
            };
            result[cur].value *= 2;
            extraScore += result[cur].value;
        } else {
            // console.log("Copying element", j, elements[j]);
            merged = false;
            result.push({
                ...elements[j]
            });
        }
        for(let j = 0; j < result.length; ++j){
            //            console.log("Changing value of", result[j], "to", reverse ? 3 - j : j);
            result[j][changingField] = reverse ? 3 - j : j;
            newCells.push(result[j]);
        }
    }
    $45901ec53360e327$var$orderCells(newCells);
    return {
        ...oldState,
        cells: newCells,
        removed: deleted,
        score: oldState.score + extraScore
    };
}
function $45901ec53360e327$var$sameState(state1, state2) {
    if (state1.cells.length !== state2.cells.length) return false;
    for(let i = 0; i < state1.cells.length; ++i){
        const c1 = state1.cells[i];
        const c2 = state2.cells[i];
        if (c1.top !== c2.top || c1.left != c2.left || c1.value != c2.value) return false;
    }
    return true;
}
function $45901ec53360e327$var$loop(oldState, direction) {
    let newState = $45901ec53360e327$var$move(oldState, direction);
    if ($45901ec53360e327$var$sameState(oldState, newState)) {
        console.log("State", oldState, "and", newState, "are the same, ignoring");
        return;
    }
    newState = $45901ec53360e327$var$addRandomCell(newState);
    if ($45901ec53360e327$var$isGameOver(newState)) {
        newState.playing = false;
        $45901ec53360e327$var$highScore = Math.max($45901ec53360e327$var$highScore, newState.score);
        localStorage["high-score"] = $45901ec53360e327$var$highScore;
    }
    $45901ec53360e327$var$refreshBoard(newState);
    $45901ec53360e327$var$state = newState;
}
function $45901ec53360e327$var$computeScore(state) {
    //return state.cells.map( c => c.value ).reduce( (a,b) => a+b );
    return state.score;
}
function $45901ec53360e327$var$refreshBoard(state) {
    const board = document.getElementById("game");
    for (const c of state.cells){
        c.element.textContent = c.value + "";
        if (c.element.parentElement !== board) {
            c.element.className = `invisible cell top-${c.top} left-${c.left} value-${c.value} `;
            board.appendChild(c.element);
            setTimeout(()=>{
                c.element.className = `cell top-${c.top} left-${c.left} value-${c.value} `;
            }, 0);
        } else c.element.className = `cell top-${c.top} left-${c.left} value-${c.value} `;
    }
    for (const d of state.removed){
        d.element.className = `cell top-${d.top} left-${d.left} value-${d.value} removed`;
        setTimeout(()=>d.element.remove(), 5000);
    //            d.element.remove();
    }
    const score = $45901ec53360e327$var$computeScore(state);
    document.getElementById("score").innerText = "" + score;
    document.getElementById("high-score").innerText = "" + $45901ec53360e327$var$highScore;
    if (state.playing) {
        document.getElementById("end").style.visibility = "hidden";
        document.getElementById("result").innerText = "";
    } else {
        document.getElementById("result").innerText = "Game Over !";
        document.getElementById("end").style.visibility = "visible";
    }
}
function $45901ec53360e327$var$isGameOver(state) {
    if (state.cells.length !== 16) return false;
    const value = {};
    for (const cell of state.cells)value[`${cell.left}-${cell.top}`] = cell.value;
    for(let i = 0; i < 4; ++i)for(let j = 0; j < 4; ++j){
        const x1 = value[`${i}-${j}`];
        const x2 = value[`${i + 1}-${j}`];
        const x3 = value[`${i}-${j + 1}`];
        // note we may go out of bounds here but it works in
        // our favor
        if (x1 === x2 || x1 === x3) return false;
    }
    return true;
}
function $45901ec53360e327$var$moveUp() {
    $45901ec53360e327$var$loop($45901ec53360e327$var$state, "up");
}
function $45901ec53360e327$var$moveDown() {
    $45901ec53360e327$var$loop($45901ec53360e327$var$state, "down");
}
function $45901ec53360e327$var$moveLeft() {
    $45901ec53360e327$var$loop($45901ec53360e327$var$state, "left");
}
function $45901ec53360e327$var$moveRight() {
    $45901ec53360e327$var$loop($45901ec53360e327$var$state, "right");
}
$45901ec53360e327$var$resetBoard();


//# sourceMappingURL=index.9e268424.js.map
